import { ArrowLeft, Mail } from 'lucide-react'
import { useState, type FormEvent } from 'react'
import { Link, useLocation } from 'react-router'

import { cuenta } from '../api/cuenta'
import { ErrorDeLaApi } from '../api/nucleo'
import { PantallaDeAcceso } from '../componentes/Acceso'
import { Aviso, Boton, Campo } from '../componentes/ui'

/**
 * «¿Has olvidado tu contraseña?». El núcleo responde lo mismo exista o no el correo —no
 * dice quién tiene cuenta— y, si existe, manda un enlace de una hora a `/restablecer`.
 */
export const Olvide = () => {
  const { state } = useLocation()
  const inicial = typeof (state as { email?: unknown })?.email === 'string' ? (state as { email: string }).email : ''
  const [email, setEmail] = useState(inicial)
  const [enviando, setEnviando] = useState(false)
  const [enviado, setEnviado] = useState(false)
  const [fallo, setFallo] = useState<null | string>(null)

  const enviar = async (e: FormEvent) => {
    e.preventDefault()
    setEnviando(true)
    setFallo(null)
    try {
      await cuenta.pedirEnlace(email.trim())
      setEnviado(true)
    } catch (error) {
      setFallo(error instanceof ErrorDeLaApi ? error.message : 'No hemos podido conectar. Comprueba tu conexión y vuelve a intentarlo.')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <PantallaDeAcceso>
      {enviado ? (
        <div>
          <span aria-hidden className="mb-5 flex size-11 items-center justify-center rounded-full bg-violeta-suave text-violeta">
            <Mail className="size-5" />
          </span>
          <h1 className="font-display text-[26px] font-semibold tracking-tight">Mira tu correo</h1>
          <p className="mt-3 text-sm text-tinta-2">
            Si hay una cuenta con <strong className="font-medium">{email.trim()}</strong>, te acabamos de mandar un enlace para poner una contraseña nueva. Vale una hora.
          </p>
          <p className="mt-2 text-sm text-tenue">Si no llega en unos minutos, mira en la carpeta de correo no deseado, o vuelve a pedirlo.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Link to="/entrar">
              <Boton icono={<ArrowLeft />}>Volver a entrar</Boton>
            </Link>
            <Boton onClick={() => setEnviado(false)} tipo="discreto">
              Pedirlo otra vez
            </Boton>
          </div>
        </div>
      ) : (
        <form onSubmit={enviar}>
          <h1 className="font-display text-[26px] font-semibold tracking-tight">¿Has olvidado tu contraseña?</h1>
          <p className="mt-2 text-sm text-tenue">Escribe el correo con el que entras y te mandamos un enlace para poner una nueva.</p>
          <div className="mt-8 flex flex-col gap-4">
            <Campo autoComplete="email" autoFocus etiqueta="Correo" onChange={(e) => setEmail(e.target.value)} required type="email" value={email} />
            {fallo && <Aviso tono="error">{fallo}</Aviso>}
            <Boton cargando={enviando} className="w-full" tipo="primario" type="submit">
              Mandarme el enlace
            </Boton>
            <Link className="self-center text-[13px] text-tenue hover:text-tinta" to="/entrar">
              Ya me acuerdo: volver a entrar
            </Link>
          </div>
        </form>
      )}
    </PantallaDeAcceso>
  )
}
